/**
 * 一路多单订单管理
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import moment from 'moment';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton, XTabNav } from '@/components/xqxc_ui';
import TableContent from './components/OrderTable';
import KeepAlive from '@/routes/KeepAlive';
import model from '@/reducers/order/distributionorder/model';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        shareLoading: false,
    };

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }
    // 表格操作
    _tableAction = (key, type, record) => {
        const { history } = this.props;
        switch (type) {
             // 一路多单详情
             case 'multiinfo':
                history.push({
                    pathname: `/home/order/distributionorder/multiorderdetail/${key}`,
                });
                break;
        }

    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, deliveryGroupId, shipperPhone, createTimeStart, createTimeEnd
        } = this.state;
        const query = {
            deliveryGroupId,
            shipperPhone,
            createTimeStart,
            createTimeEnd,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getDeliveryGroupList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({
            deliveryGroupId: undefined, shipperPhone: undefined,
           createTimeStart: undefined, createTimeEnd: undefined, pageNum: 1, pageSize: 10
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }
    startDate = () => {
        this.setState({ createTimeEnd: undefined });
    }
    disabledDate = (current) => {
        const { createTimeStart } = this.state;
        let enddays = createTimeStart && moment(createTimeStart);
        return current && current < enddays && enddays.startOf('day');
    }
    deliveryIdHandle = e => {
        var value = e.target.value;
        const reg = /^[0-9a-zA-Z]*$/; // 数字、字母
        if (value && value.toString().length > 21) {
            return;
        } else if (!reg.test(value)) {
            this.setState({ deliveryId: undefined });
        }
    }
    render() {
        const { deliveryGroupId, shipperPhone, createTimeStart, createTimeEnd  } = this.state;
        const { DeliveryGroupList } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache');
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                
                        <SearchBox>
                            <SearchItem>
                                <XInput
                                    label='订单号'
                                    placeholder='请输入订单号'
                                    value={deliveryGroupId}
                                    bindThis={this}
                                    bindName='deliveryGroupId'
                                    // min={0}
                                    // precision={0}
                                    onBlur={this.deliveryIdHandle}
                                    maxLength={21}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInputNum
                                    label='发货人手机'
                                    placeholder='请输入发货人手机'
                                    value={shipperPhone}
                                    bindThis={this}
                                    bindName='shipperPhone'
                                    min={0}
                                    precision={0}
                                    maxLength={11}
                                />
                            </SearchItem>                         
                            <SearchItem>
                                <XDatePicker
                                    label='下单时间'
                                    value={createTimeStart}
                                    bindThis={this}
                                    bindName='createTimeStart'
                                    isFormat
                                    showTime={false}
                                    defaultTime='00:00:00'
                                    onChange={this.startDate}
                                />
                                <div className={styles.timeLine} />
                                <XDatePicker
                                    style={{ marginRight: 20 }}
                                    label=''
                                    value={createTimeEnd}
                                    bindThis={this}
                                    bindName='createTimeEnd'
                                    isFormat
                                    showTime={false}
                                    defaultTime='23:59:59'
                                    disabledDate={this.disabledDate}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                   
                    <TableContent
                        renderData={DeliveryGroupList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
    match: PropTypes.object,
    getDeliveryGroupList: PropTypes.func,
    DeliveryGroupList: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
};
const mapStateToProps = (state) => ({
    DeliveryGroupList: state.distributionorder.DeliveryGroupList,
});
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);